<template>
	<ModalBox @hideModal="$emit('hideModal')">
		<template #content>
			<div class="modal__content_message">
				<div class="modal__content_header-success">
					<img src="@/assets/images/green-check.svg">
				</div>
				<div class="modal__content_text modal__content_text-success">
					Вы успешно отписались от рассылки.
				</div>
				<div class="modal__content_button modal__content_button-zero">
					<MainButton title="ОК" @click="$emit('hideModal')" size="small" color="yellow-round" />
				</div>
			</div>
		</template>
	</ModalBox>
</template>

<script>
import MainButton from "@/components/ui/Button/MainButton.vue";
import ModalBox from "@/components/template/ModalBox.vue";

export default {
	name: "ModalUnsubscribe",
	components: {ModalBox, MainButton}
}
</script>

<style scoped lang="scss">

</style>